import React, { useMemo, useState, useEffect } from "react";
import { useAxiosContext } from "../../../context/AxiosContext";
import Input from "../../../components/FormComponents/Input";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import Button from "../../../components/FormComponents/Button";

import "./MobileHeader.css";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { getLogoUrl } from "../../../utils/screenutils";

export const ImagePreview = ({ file }) => {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  }, [file]);

  return <img src={preview} accept="image/*" alt="Preview" style={{ width: "150px", height: "150px" }} />;
};

const HeaderLogoModal = ({ saveHeaderLogodata, currentLogoData, onClose }) => {
  const [logoData, setLogoData] = useState(currentLogoData);
  const [isLogoUpload, setIsLogoUpload] = useState(true);
  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();
  const [file, setFile] = useState(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    setFile(file);
  };

  const handleSaveLogo = async () => {
    try {
      if (file) {
        const formData = new FormData();
        formData.append("myFile", file);
        const response = await axiosInstance.post(`/public/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });

        // const uploadedLogoSrc = `${BASE_URL}/api/v1/public/${response.data.name}`;
        const uploadedLogoSrc = `${response.data.name}`;

        setLogoData({
          ...logoData,
          logosrc: uploadedLogoSrc,
          original_name: response.data.original_name
        });

        // After setting the logoData with the uploaded image source, save the logo data
        saveHeaderLogodata({
          ...logoData,
          logosrc: uploadedLogoSrc // Ensure to use the uploaded image source
        });

        handleSuccess(response.message);
      } else {
        // If no file is selected, just save the current logo data
        saveHeaderLogodata(logoData);
      }
      onClose();
    } catch (error) {
      handleError(error);
    }
  };

  const logoElementText = useMemo(() => {
    if (!isLogoUpload && logoData.logotext && logoData.logotext.length !== 0) {
      return (
        <span
          style={{
            fontWeight: logoData.logotextweight,
            fontSize: logoData.logotextsize + "px",
            color: logoData.logotextcolor
          }}
        >
          {logoData.logotext}
        </span>
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logoData.logotext, logoData.logotextsize, logoData.logotextweight, logoData.logotextcolor]);

  const handleDeleteLogo = () => {
    setLogoData({
      logosrc: "",
      logotext: "",
      logotextsize: "",
      logotextweight: "",
      logotextcolor: "",
      original_name: ""
    });
  };

  const toggleSection = () => {
    setIsLogoUpload(!isLogoUpload);
  };

  const fontWeightOptions = [
    { id: "100", name: "100" },
    { id: "200", name: "200" },
    { id: "300", name: "300" },
    { id: "400", name: "400" },
    { id: "500", name: "500" },
    { id: "600", name: "600" },
    { id: "700", name: "700" },
    { id: "800", name: "800" },
    { id: "900", name: "900" }
  ];

  return (
    <>
      <div className="builder_form">
        <div style={{ display: "flex", justifyContent: "left", marginBottom: "8px" }}>
          <div className={`toggle_switch ${isLogoUpload ? "active" : ""}`} onClick={toggleSection}>
            <div className="toggle_slider"></div>
          </div>
          <label className="builder_label" style={{ marginLeft: "4px" }}>
            Logo
          </label>
        </div>
        {isLogoUpload ? (
          <div className="builder_form">
            <div style={{ border: "#c0c0c1", padding: "8px", marginBottom: "8px", width: "500px" }}>
              <div>
                {!logoData.logosrc && (
                  <div>
                    <Input label="Upload Logo" type="file" accept="image/*" onChange={handleFileChange} />
                    {file && <ImagePreview file={file} />}
                  </div>
                )}
                {logoData.logosrc && (
                  <div>
                    <label className="builder_label">Loaded Logo</label>
                    <div style={{ display: "flex", justifyContent: "space-between", padding: "8px" }}>
                      <img src={getLogoUrl(logoData.logosrc)} alt="Logo" style={{ height: "40px", width: "auto" }} />
                      <MaterialIcon
                        name="delete"
                        className="builder_action_btn delete"
                        style={{ alignItems: "start" }}
                        onClick={handleDeleteLogo}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="builder_form" style={{ width: "500px" }}>
              {logoElementText && (
                <div
                  style={{
                    border: "#c0c0c1",
                    padding: "8px",
                    marginBottom: "8px",
                    width: "500px"
                  }}
                >
                  <div>
                    <label className="builder_label">Loaded Logo</label>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", padding: "8px" }}>
                    {logoElementText}
                    <div style={{ marginLeft: "auto" }}>
                      {logoElementText && (
                        <MaterialIcon
                          name="delete"
                          className="builder_action_btn delete"
                          style={{ alignItems: "start" }}
                          onClick={handleDeleteLogo}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}
              <Input
                label="Logo Text"
                placeholder="Enter Logo text"
                name="logotext"
                value={logoData.logotext}
                maxLength={40}
                onChange={(e) =>
                  setLogoData({
                    ...logoData,
                    [e.target.name]: e.target.value
                  })
                }
              />
            </div>
            <div className="builder_form">
              <Input
                label="Font Size"
                type="number"
                placeholder="Enter Font size"
                name="logotextsize"
                value={logoData.logotextsize}
                onChange={(e) =>
                  setLogoData({
                    ...logoData,
                    [e.target.name]: e.target.value
                  })
                }
              />
              <SingleSelectBox
                selectedData={logoData.logotextweight}
                options={fontWeightOptions}
                onChange={(obj) =>
                  setLogoData({
                    ...logoData,
                    logotextweight: obj.id
                  })
                }
                placeholder="Select Font Weight"
                label="Font Weight"
              />
              <Input
                label="Color"
                type="color"
                placeholder="Select Color"
                name="logotextcolor"
                value={logoData.logotextcolor}
                onChange={(e) =>
                  setLogoData({
                    ...logoData,
                    [e.target.name]: e.target.value
                  })
                }
              />
            </div>
          </>
        )}
        <Button onClick={handleSaveLogo}>Apply</Button>
      </div>
    </>
  );
};

export default HeaderLogoModal;
